<template>
  <v-card flat style="text-align:left;">
    <div class="primary white--text" id="karasaNav">
      <h1 style="font-size:20pt;">辛さ比較</h1>
      <p style="margin:0">過去に食べた食品と辛さを比較しよう！</p>
    </div>
    <v-layout row wrap>
      <v-flex style="width:40%;">
        <div id="currentFoodWrap">
          <v-btn flat block large color=primary @click="onKarasa('up')"><v-icon>expand_less</v-icon>もっと辛い</v-btn>
          <v-card style="padding:10px;" flat id="currentFood">
            <v-avatar size="100">
              <v-img :src="imageurls[0]"></v-img>
            </v-avatar>
            <div style="height:110px;width:110px;border-radius:55px;border:solid 5px #f44336;position:absolute;top:6px;left:6px"></div>
          </v-card>
          <v-btn flat block large color=primary @click="onKarasa('down')"><v-icon>expand_more</v-icon>辛くない</v-btn>
        </div>
        <div v-show="isScrollMoved" class="green white--text" id="karasa">
          <p style="margin:0">
            今まで食べた中で<br>
            <strong style="font-size:130%">{{rank+1}}番目</strong>の辛さ
          </p>
        </div>
      </v-flex>
      <v-flex id="rankWrap"> 
        <div v-show="!isScrollMoved" class="green white--text" id="ScrollNav">
          <p style="border-bottom:1px solid #fff;margin-bottom:5px;">
            <v-icon small>info</v-icon>右側をスクロール
          </p>
          <p style="margin:0">
            ランキングをスクロールして辛さを比較！
          </p>
        </div>
        <v-timeline dense id="rank">
          <v-timeline-item 
            v-for="(food, num) in foodsRank" :key=food.id
            fill-dot
            small
            right
          >
            <v-card>
              <v-list>
                <v-list-tile>
                  <v-list-tile-avatar tile>
                    <v-img :src="food.imageurl"></v-img>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <span style="font-size:10pt;font-weight:bold;">{{food.name | textTrim(16)}}</span>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <div style="position:absolute;top:-17px;left:-5px;">
                <v-chip small>{{num + 1}}位</v-chip>
              </div>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
    </v-layout>
    <v-card style="height:100px;padding:5px;">
      <v-btn block color="primary" dark @click="onSend('save')">
        <div v-if="isLoading">
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </div>
        <span v-else>辛さ比較を登録する</span>
      </v-btn>
      <v-btn block color="black" outline @click="onSend('skip')">
        <div v-if="isLoading">
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </div>
        <span v-else>スキップする</span>
      </v-btn>
    </v-card>
  </v-card>
</template>

<script>
import { db } from '@/main'
import getImageUrl from '@/assets/js/getImageUrl.js'

var rankObjHeight = 64;
var headerHight = 96;
var diff = 88;

// @ is an alias to /src
export default {
  name: 'KarasaHikakuForm',
  data () {
    return {
      isLoading: false,
      rankId: '',
      foodsRank: [],
      skips: [],
      karasa: 5,
      rankParam: 0,
      loadedImage: 0,
      rank: '',
      isScrollMoved: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    postId () {
      if (this.$store.state.temp.postId) return this.$store.state.temp.postId
      return '' 
    },
    foodId () {
      return this.$store.state.temp.id
    },
    food () {
      return this.$store.state.temp.foodData
    },
    imageurls () {
      return this.$store.state.temp.images
    },
    isImageLoaded () {
      if (this.loadedImage === this.foodsRank.length && this.loadedImage > 0) return true
      return false 
    } 
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
    let element = document.getElementById('rankWrap')
    element.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
      let element = document.getElementById('rankWrap')
      let y = element.scrollTop
      let rank = 0
      this.isScrollMoved = true
      for (let i = 0; i <= this.foodsRank.length; i++) {
        let yi = headerHight + rankObjHeight / 2 + diff * i + 10 - 100
        if (y < yi) {
          rank = i
          this.rank = rank
          break
        }
      }
    },
    onKarasa (mode) {
      let element = document.getElementById('rankWrap')
      if (mode === 'up') {
        element.scrollTop = element.scrollTop - diff
      } else {
        element.scrollTop = element.scrollTop + diff
      }
    },
    async onSend (mode) {
      if (this.isLoading) return
      this.isLoading = true
      let obj = {}
      if (mode === 'save') {
        obj = this.makeRankObj()
      } else if (mode === 'skip') {
        obj = this.makeSkipObj()
      }

      if (this.foodsRank.length > 0) {
        await db.collection('rank').doc(this.rankId).set(obj, {merge: true})
        this.$emit('onFinish')
      } else {
        this.$emit('onFirstRank')
        await db.collection('rank').doc(this.user.uid).set(obj, {merge: true})
      }
    },
    makeRankObj () {
      let timestamp = new Date()
      // レビュー対象の食品を追加
      let f = this.food
      let foodObj = {
        id: f.id,
        name: f.name,
        postId: this.postId,
        timestamp: timestamp
      }
      if (f.images) foodObj.images = f.images
      if (f.category) foodObj.category = f.category
      
      let l = []  
      if (this.foodsRank.length > 0) {
        this.foodsRank.splice(this.rank, 0, foodObj)        
        let rank = 1
        for (let i = 0; i < this.foodsRank.length; i++) {
          this.foodsRank[i].rank = rank
          rank++
        }
        l = this.foodsRank
      }
      else {
        foodObj.rank = 1
        l.push(foodObj)
      }
      let obj = {
        foods: l,
        user: this.user
      }
      return obj
    },
    makeSkipObj () {
      let timestamp = new Date()
      let list = this.skips
      let f = this.food
      let foodObj = {
        id: f.id,
        name: f.name,
        postId: this.postId,
        timestamp: timestamp
      }
      if (f.images) foodObj.images = f.images
      if (f.category) foodObj.category = f.category
 
      list.push(foodObj)
      let obj = {
        skips: list
      }
      return obj
    },
    async init () {
      let response = await db.collection('rank').where('user.uid', '==', this.user.uid).get()
      response.forEach(doc => {
        let data = doc.data()
        this.rankId = doc.id
        data.foods.forEach(f => {
          if (this.foodId !== f.id) {
            this.foodsRank.push(f)
          }
        })        
        if (data.skips) {
          this.skips = data.skips
        }
      })
      for (let i = 0; i < this.foodsRank.length; i++) {
        let food = this.foodsRank[i]
        this.foodsRank[i].imageurl = getImageUrl.get('food_thumbs', food.id, food.images[0])
      }

      if (this.foodsRank.length === 0) {
        this.onSend('save')
      }
      // console.log(this.foodsRank)
    }
  },
  components: {
  }
}
</script>
<style scoped>
#rankWrap {
  width: 60%;
  overflow-y: scroll;
  height: calc(100vh - 196px);
}
#rank >>> .v-timeline-item:first-child {
  padding-top: calc(50vh - 100px);
}
#rank >>> .v-timeline-item:last-child {
  padding-bottom: calc(50vh - 88px + 24px);
}
#rankWrap >>> .v-timeline {
  padding-top: 0;
}

#rank >>> .v-timeline-item__dot--small {
  height:10px;
  width:10px;
  left: 14px;
}
#rank >>> .v-timeline-item__body{
  max-width: calc(100% - 35px);
}
#currentFoodWrap {
  position: absolute;
  width:150px;
  top: calc(50vh - 96px - 130px);
  left: calc(40% - 140px)
}
#currentFood:after {
  content: "";
  position: absolute;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 50px solid #f44336;
  top: calc(50% - 5px);
  margin-left:7px;
}
#karasaNav {
  padding: 10px 16px;
  position: absolute;
  top:0px;
  z-index:3;
  width:80%;
  border-top-right-radius : 8px;
	-webkit-border-top-right-radius: 8px;
	-moz-border-radius-topright: 8px;
	border-bottom-right-radius : 8px;
	-webkit-border-bottom-right-radius: 8px;
	-moz-border-radius-bottomright: 8px;
}
#karasa {
  padding: 10px 16px;
  position: absolute;
  bottom: 120px;
  z-index:3;
  width:40%;
  background-color: #ddd;
  border-top-right-radius : 8px;
	-webkit-border-top-right-radius: 8px;
	-moz-border-radius-topright: 8px;
	border-bottom-right-radius : 8px;
	-webkit-border-bottom-right-radius: 8px;
	-moz-border-radius-bottomright: 8px;
}

#ScrollNav {
  padding: 10px 16px;
  position: absolute;
  top: 110px;
  right:5px;
  z-index:3;
  width:50%;
  border-radius:8px;
}
</style>
